export default {
    GET_LOCALIZATION_SCREEN_GROUPS_REQUEST: state => {
        state.localizationScreenGroupsLoading = true
    },
    GET_LOCALIZATION_SCREEN_GROUPS_SUCCESS: (state, data) => {
        state.localizationScreenGroups = data
        state.localizationScreenGroupsLoading = false
    },
    GET_LOCALIZATION_SCREEN_GROUPS_FAILURE: state => {
        state.localizationScreenGroupsLoading = false
    },
}